import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6319dd2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "count" }

import Typography from '@/components/Rain/Typography/Typography.vue'

interface Props {
    itemName: string
    itemCount: number
    type?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddleSalesItem',
  props: {
    itemName: { default: undefined },
    itemCount: { default: 0 },
    type: { default: 'summary' }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['sales-item', `sales-item--${_ctx.type}`])
  }, [
    _createVNode(Typography, {
      variant: "body2",
      class: "item-name"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.itemName), 1)
      ], undefined, true),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.itemCount), 1)
  ], 2))
}
}

})